import request from "@/utils/request";

// 分页列表(主数据列表)
export function loadDictDataApi(data) {
  return request({
    url: "web/dict/findDictByCondition",
    method: "post",
    data
  });
}

